import { savingscard_effects } from 'packs/mynails_effects';
import { BrowserQRCodeReader, ReedSolomonException } from '@zxing/library';

window.addEventListener("turbolinks:load", () => {

  const links = document.querySelectorAll(
    "button#scan-my-qrcode"
  );

  const codeReader = new BrowserQRCodeReader();

  links.forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      
      $(document.querySelector('#slideshow')).hide();

      $(document.querySelector('#qrc-scanner')).show();

      //
      // Pre-load audio otherwise will not work on ios
      //
      document.querySelector("audio#audio-effect-fullcard").load();
      document.querySelector("audio#audio-effect-fullcard-cash").load();
      document.querySelector("audio#audio-effect-fullcard-cash-cash").load();
      document.querySelector("audio#audio-effect-kassa").load();
      document.querySelector("audio#audio-effect-kassa2").load();
      document.querySelector("audio#audio-effect-claim-fullcard").load();


      // Your delay in milliseconds
      var delay = 240000; 
      setTimeout(function(){ window.location.reload(); }, delay);


      var find_camera;

      // Function to dispose of codeReader and release camera resources
      function disposeCodeReader() {
        if (codeReader) {
            codeReader.reset(); // Reset codeReader (if necessary)
            codeReader = null; // Release the reference to the codeReader object
        }
      }

      codeReader
        .listVideoInputDevices()
        .then(videoInputDevices => {
          videoInputDevices.forEach(device =>
            find_camera = device.deviceId
            //alert(device.label)
          );
          //console.log(`${device.label}, ${device.deviceId}`
        })
        .catch(err => console.error(err));

      codeReader
        .decodeFromInputVideoDevice(find_camera, 'video')
        .then((result) => {

          let qrDataFromReader = result.text;
          $.ajax({
            url: "/mynails/qrcodetracker/" + result.text,
            method: "POST",
            dataType: "html",
            error: function (xhr, status, error) {
                console.error('AJAX Error: ' + status + error);
                disposeCodeReader(); // Dispose of codeReader in case of error
            },
            success: function (response) {
              
              $(document.querySelector('#qrc-scanner')).hide();
              $(document.querySelector('#qrc-scanner-result')).append(response);

              disposeCodeReader();

              document.querySelector("button#back-to-main-qrcode").addEventListener("click", (event) => {
                window.location.reload();
              })

              // Your delay in milliseconds
              var delay = 120000; 
              setTimeout(function(){ window.location.reload(); }, delay);

              savingscard_effects();
            }
          });

        })
        .catch(err => console.error(err));

    });
  });

  const claim_by_email = document.querySelector("button#claim-by-email");
  if (claim_by_email) {
    claim_by_email.addEventListener("click", (event) => {
      event.preventDefault();

      $.ajax({
        url: "/mynails/qrcodetracker/?email=" + document.querySelector("#claim-email-adress").value,
        method: "POST",
        dataType: "html",
        error: function (xhr, status, error) {
            console.error('AJAX Error: ' + status + error);
            alert(xhr.responseText);
        },
        success: function (response) {
          $(document.querySelector('#qrc-scanner')).hide();
          $(document.querySelector('#qrc-scanner-result')).append(response);

          disposeCodeReader();

          // Your delay in milliseconds
          var delay = 120000; 
          setTimeout(function(){ window.location.reload(); }, delay);

          savingscard_effects();
        }
      });

    });
  } else {
    console.warn("Button with ID 'claim-by-email' not found.");
  }

});




